import BaseService from "service/base.js";

class MediaLibraryService {
  archive(items) {
    return BaseService.put("/api/content-library/archive", { items });
  }
}

const mediaLibraryService = new MediaLibraryService();
export { mediaLibraryService };
